import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentTab: 1,
};

export const tabSlices = createSlice({
  name: "currentTab",
  initialState,
  reducers: {
    nextTab: (state, action) => {
      state.currentTab += 1;
    },
    preTab: (state, action) => {
      state.currentTab -= 1;
    },
    customTab: (state, { payload }) => {
      state.currentTab = payload;
    },
    resetTab: (state) => {
      state.currentTab = 1;
    },
  },
});

export const { nextTab, preTab, customTab, resetTab } = tabSlices.actions;

export default tabSlices.reducer;
